<template>
  <v-container
    id="dashboard"
    fluid
    tag="section"
    class="px-3 pt-0"
    style="margin-top: 1rem"
  >
    <v-row>
      <v-col
        cols="12"
        lg="12"
        class="px-1"
      >
        <base-material-card
          id="inicio"
          :color="corPrimaria"
          class="text-h1"
        >
          <template v-slot:heading>
            <div
              class="text-h3 font-bold-light"
            >
              <v-icon
                id="iconDashboard"
                class="text-h2"
              >
                mdi-view-dashboard
              </v-icon>
              Seja bem vindo na nossa loja
            </div>
          </template>
        </base-material-card>

        <v-divider class="mb-7" />
        <v-col
          v-if="promocao"
          cols="12"
          lg="12"
        >
          <div class="col-12">
            <h2>Produtos em promoção</h2>
            <hr><hr><br>
            <div>
              <ul
                id="ul_productPromocao"
              >
                <li
                  v-for="produto in produtos"
                  id="li_productPromocao"
                  :key="produto.id"
                  class="col-5 lg-6 mb-4 my-2"
                >
                  <div>
                    <div
                      v-if="produto.imagem"
                      id="imagemProdutoPromocao"
                    >
                      <v-img
                        id="imagemPromocao"
                        :src="produto.imagem"
                        contain
                      />
                    </div>
                    <span id="nomeProdutoPromocao">{{ produto.nome }}</span>
                    <span id="precoProdutoPromocao"> R$ {{ produto.precoExibicao }}
                    </span>
                    <v-row>
                      <v-btn
                        id="btnProdutoPromocao"
                        class="col-3 lg-6"
                        small
                        :color="corPrimaria"
                        dark
                        @click="showDescricao(produto)"
                      >
                        Ver mais
                      </v-btn>
                      <v-btn
                        id="btnProdutoPromocao"
                        small
                        :color="corPrimaria"
                        dark
                        @click="addItem(produto)"
                      >
                        Adicionar
                      </v-btn>
                    </v-row>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </v-col>
      </v-col>
      <v-divider class="mb-7" />
    </v-row>

    <!-- <div
      id="titulo"
    >
      <h4>Saiba como utilizar a versão web</h4>
    </div>
    <div id="video">
      <youtube-embed
        id="youtube"
        :video-id="'by2hvcX7xSA'"
      />
    </div> -->
    <dashboard-core-snackbar
      v-model="snackbar.visible"
      :visible="snackbar.visible"
      :timeout="snackbar.timeout"
      :color="snackbar.color"
      :message="snackbar.message"
    />
  </v-container>
</template>

<script>
  import Login from '../../services/login'
  import utils from '../../services/utils'
  import { mapState } from 'vuex'
  // import YoutubeEmbed from '../../components/base/YoutubeEmbed'
  import ListaProdutos from '../../services/listaprodutosservice'
  import Carrinho from '../../services/carrinhoservice'

  export default {
    name: 'DashboardDashboard',
    components: {
      // YoutubeEmbed,
      DashboardCoreSnackbar: () => import('./components/core/Snackbar'),
    },
    mixins: [utils],
    data: vm => ({
      appOnline: navigator.onLine,
      nomeUsuario: localStorage.nome,
      snackbar: {
        visible: false,
        color: 'success',
        message: '',
        timeout: 3000,
      },
      produtos: [],
      produtoNomes: [],
      itensCarrinho: [],
      promocao: null,
      carrinho: [],
      corPrimaria: localStorage.corPrimaria,
      user: [],
      cart: 0,
      loading: false,
    }),

    computed: {
      ...mapState(['versao']),
    },

    mounted () {
      if (localStorage.chaveativacao) {
        this.loading = true

        localStorage.removeItem('linhaSelect')
        localStorage.removeItem('classificacaoSelect')

        Login.verificaAcessoUsuario(localStorage.chaveativacao).then(resposta => {
          if (resposta.data.status !== 'ativo') {
            this.limpaDadosOffline()
            this.$router.push('/registrar')
          }

          localStorage.setItem('usuarioIdentificado', resposta.data.usuario_identificado)

          this.showCart()
          this.showProdutos()
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, ' Falha na conexão com a internet')
            this.appOnline = false
          } else if (e.data && e.data.errors === 'Usuário não encontrado') {
            this.limpaDadosOffline()
            this.$router.push('/registrar')
          }
        })
      } else {
        this.limpaDadosOffline()
        this.$router.push('/login')
      }
    },

    methods: {
      showCart () {
        localStorage.removeItem('carrinhoId')

        Carrinho.show(localStorage.username, localStorage.tokencontrato).then(resposta => {
          this.itensCarrinho = resposta.data.itensCarrinho
          if (this.itensCarrinho) {
            this.produtoNomes = this.itensCarrinho
            this.cart = this.produtoNomes.length
            this.bloqueado = resposta.data.bloqueado
            this.inativo = resposta.data.inativo

            localStorage.bloqueado = this.bloqueado
            localStorage.inativo = this.inativo

            localStorage.setItem('carrinhoId', this.itensCarrinho[0].carrinhoId)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else {
            this.showSnackbar('error', 3000, e.response.data.mensagem + ' - Erro ao carregar informações')
          }
        })
      },

      showProdutos () {
        ListaProdutos.showPromocao(localStorage.username, localStorage.contrato_id).then(resposta => {
          if (resposta.data.produto) {
            this.produtos = resposta.data.produto
            this.promocao = true

            localStorage.removeItem('produtoId')
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        })
      },

      /* Método que envia as informações para buscar a descrição do produto */
      showDescricao (produto) {
        this.produtoid = produto.idProduto

        localStorage.setItem('produtoId', this.produtoid)

        this.$router.push('/descricao-produto')
      },

      addItem (produto) {
        this.produtoNomes.push(produto)

        this.consultar = this.produtoNomes

        this.produtoNomes = this.produtoNomes.map((lista) => {
          var listacompra = ({
            id: lista.id,
            idProduto: lista.idProduto,
            nome: lista.nome,
            preco: lista.preco,
            precoExibicao: lista.precoExibicao,
            unidade: lista.unidade,
            quantidade: !lista.quantidade ? 1 : lista.quantidade,
            pecasPorCaixa: lista.pecasPorCaixa,
            estoque: lista.estoque,
            desconto: lista.desconto,
            referenciaUnidade: lista.referenciaUnidade,
            peso: lista.peso,
            dataInicio: lista.dataInicio ? lista.dataInicio : null,
            dataFim: lista.dataFim ? lista.dataFim : null,
            imagem: lista.imagem,
          })

          return listacompra
        })

        // função separa os produtos em grupos, caso o usuário clique em um produto
        // que já esteja no carrinho ele o agrupa os itens iguais
        function groupBy (array, f) {
          var groups = {}
          array.forEach(function (o) {
            var group = JSON.stringify(f(o))
            groups[group] = groups[group] || []
            groups[group].push(o)
          })
          return Object.keys(groups).map(function (group) {
            return groups[group]
          })
        }

        // percorrer os produtos do carrinho realizando a soma da quantidade dos itens
        // iguais da lista, realizando a soma da quantidade de cada produto
        // e entrega o array sem produtos repetidos
        var produtosIguais = groupBy(this.produtoNomes, function (item) {
          return [item.idProduto, item.nome]
        }).map((data) => {
          return {
            total: data.reduce((total, valor) => total + valor.quantidade, 0),
            itens: data,
          }
        })

        // preenche o array para ser usado na adição do carrinho
        for (var i in produtosIguais) {
          var id = produtosIguais[i].itens[0].id
          var idProduto = produtosIguais[i].itens[0].idProduto
          var nome = produtosIguais[i].itens[0].nome
          var preco = produtosIguais[i].itens[0].preco
          var precoExibicao = produtosIguais[i].itens[0].precoExibicao
          var unidade = produtosIguais[i].itens[0].unidade
          var quantidade = produtosIguais[i].total
          var pecasPorCaixa = produtosIguais[i].itens[0].pecasPorCaixa
          var estoque = produtosIguais[i].itens[0].estoque
          var desconto = produtosIguais[i].itens[0].desconto
          var referenciaUnidade = produtosIguais[i].itens[0].referenciaUnidade
          var peso = produtosIguais[i].itens[0].peso
          var dataInicio = produtosIguais[i].itens[0].dataInicio
          var dataFim = produtosIguais[i].itens[0].dataFim
          var imagem = produtosIguais[i].itens[0].imagem

          this.carrinho[i] = {
            id: id,
            idProduto: idProduto,
            nome: nome,
            preco: preco,
            precoExibicao: precoExibicao,
            quantidade: quantidade,
            unidade: unidade,
            pecasPorCaixa: pecasPorCaixa,
            estoque: estoque,
            desconto: desconto,
            referenciaUnidade: referenciaUnidade,
            peso: peso,
            dataInicio: dataInicio,
            dataFim: dataFim,
            imagem: imagem,
          }
        }

        // Percorrer todos os produtos e retornar apenas um item de cada
        this.produtoNomes = this.produtoNomes.filter(function (a) {
          return !this[JSON.stringify(a.idProduto)] && (this[JSON.stringify(a.idProduto)] = true)
        }, Object.create(null))

        if (this.consultar.length > this.produtoNomes.length) {
          if (this.bloqueado === 1) {
            this.showSnackbar('error', 10000, this.obsBloqueado)
          } else {
            this.showSnackbar(this.corPrimaria, 2000, 'Produto já estava no carrinho, foi adicionado mais um item do mesmo na lista de compra.')
          }
        } else {
          if (this.bloqueado === 1) {
            this.showSnackbar('error', 10000, this.obsBloqueado)
          } else {
            this.showSnackbar(this.corPrimaria, 2000, 'Produto adicionado com sucesso.')
          }
        }

        this.addCarrinho()
      },

      async addCarrinho () {
        const carrinho = this.carrinho.map((lista) => {
          var listacompra = ({
            id: lista.id,
            idProduto: lista.idProduto,
            nome: lista.nome,
            preco: lista.preco,
            precoExibicao: lista.precoExibicao,
            unidade: lista.unidade,
            quantidade: !lista.quantidade ? 1 : lista.quantidade,
            pecasPorCaixa: lista.pecasPorCaixa,
            estoque: lista.estoque,
            desconto: lista.desconto,
            referenciaUnidade: lista.referenciaUnidade,
            peso: lista.peso,
            dataInicio: lista.dataInicio,
            dataFim: lista.dataFim,
            imagem: lista.imagem,
          })

          return listacompra
        })

        await Carrinho.cartAdd(carrinho, localStorage.username, localStorage.tokencontrato).then(resposta => {
          if (resposta.data.status === true) {
            this.itensCarrinho = resposta.data.itensCarrinho

            this.cart = carrinho.length

            this.updateCart()
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          } else if (e.data.status === false) {
            this.showSnackbar('error', 10000, e.data.msg)
          }
        })
      },

      /* Método que atuliza o ícone da quantidade itens no pedido */
      updateCart () {
        this.$root.$emit('update-cart', this.cart)
      },

      showSnackbar (color, timeout, message) {
        this.snackbar.message = message
        this.snackbar.color = color
        this.snackbar.visible = true
        this.snackbar.timeout = timeout
      },
      salvarDadosOffline () {
        localStorage.username = this.login.username
        localStorage.nome = this.login.nome
        localStorage.email = this.login.email
      },

      limpaDadosOffline () {
        // localStorage.removeItem('codigoativacaotemp')
        localStorage.removeItem('chaveativacao')
        // localStorage.removeItem('countDownViewMenu')
        localStorage.clear()
      },
    },

    salvarDadosOffline () {
      // Dados do usuario =========================================v
      localStorage.nome = this.login.nome
      localStorage.username = this.login.username
      localStorage.email = this.login.email
      // Dados do usuario =========================================^
    },

    carregarDadosOffiline () {
      if (localStorage.nome) {
        this.login.nome = localStorage.nome
      }

      if (localStorage.username) {
        this.login.username = localStorage.username
      }

      if (localStorage.email) {
        this.login.email = localStorage.email
      }
    },
  }
</script>

<style lang="sass">
  #video
    text-align: center

  #inicio
    font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif !important
    font-weight: 800 !important

  #titulo
    margin-left: 1.6em
    font-family: 'Gill Sans', 'Gill Sans MT', Calibri, 'Trebuchet MS', sans-serif
    font-size: large
    text-align: justify

  #dashboard
    margin-top: 4em

  #iconDashboard
    margin-bottom: 5px

  #youtube
    width: 50rem
    margin: auto

  #ul_productPromocao
    list-style-type: none

  #li_productPromocao
    border-style: none
    box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.3)
    width: 30%
    text-align: center
    float: left
    margin-right: 10px
    border-color: green

  #precoProdutoPromocao
    font-size: 20px
    display: grid
    align-items: center
    margin: 0.7rem auto
    font-weight: bold

  #nomeProdutoPromocao
    margin-top: 1rem
    display: flex
    align-items: left
    font-weight: bold
    font-size: 14px

  #btnProdutoPromocao
    display: grid
    border-radius: 1.8rem
    float: none
    margin: 1.5rem auto

  #linhaHorizontalPromocao
    width: 100%
    border: 1px solid gray
    margin-top: 1rem

  #imagemProdutoPromocao
    margin: auto

  #imagemPromocao
    margin: auto
    display: grid
    width: 256px
    height: 256px

</style>
